<script lang="ts">
  import { Button, Col, Image } from "sveltestrap";
  import { ViewedYourProfile } from "../../../utils/Constant/Constant";
  import Card from "../../Core/Card.svelte";
  import data from "../../../Data/SocialApp/SocialApp.json"
  let imgPath:string = "/assets/images/user"
</script>
<Col sm="12" >
  <Card headerTitle={ViewedYourProfile} cardBodyprops="avatar-showcase pt-0">
    <div slot="contentbody">
      <div class="pepole-knows">
        <ul>
          {#each data.viewyourdata as viewItem }
            <li>
              <div class="add-friend text-center">
                <Image fluid class="img-60 rounded-circle" src="{imgPath}/{viewItem.img}" />
                <span class="d-block">{viewItem.name}</span>
                <Button color="primary" size="xs">{viewItem.btn}</Button>
              </div>
            </li>
          {/each}
        </ul>
      </div>
    </div>
  </Card>
</Col>